import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { UserService } from '../services/user/user.service';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { AccountService } from '../services/account/account.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { DOCUMENT } from '@angular/common';

import { NgSelectModule } from '@ng-select/ng-select';

import { forkJoin } from 'rxjs';
import { Account } from '../models/account';
import { NgIdleService } from '../services/idle-service/ng-idle.service';

// ENUM for Chart Types
const CHART_TYPE = {
  PIE: 'pie',
  LINE: 'line',
  NO_DATA: {
    text: 'No Data Found',
    color: '#999999'
  }
};

interface ResponseObject {
  readonly data: any;
  readonly errorCode: number;
  readonly message: boolean;
  readonly status: string;
}

interface ModalData {
  id: string;
  type: string;
  title: string;
  chartTitle: string;
  chartData: any;
  valueField: string;
  titleField: string;
  isLoaded: boolean;
}

interface NgSelectModuleCustom extends NgSelectModule {
  handleClearClick(): void;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  customDateFormat = "";
  selectedDateRange: Range = { fromDate: new Date(), toDate: new Date() };
  dateRangeView: string;
  chartDataErrorMessage: string;
  calendarOptions: NgxDrpOptions;
  filter = {
    fromDate: new Date(),
    toDate: new Date()
  };
  presets: Array<PresetItem> = [];
  accountId = null;
  orgId = null;
  accounts: Account[] = [];
  screeningCenters: any[] = [];
  overallDetailsData = {};
  sectionScrolled = 0;
  doc: Document;
  lazyLoadOnScrollCallback: () => void;
  isChartExtended = false;
  serviceProvidersLoaded = false;
  isOverallDataRowLoaded = false;
  charts = {
    isServicesTakenLoaded: false,
    isServicesTakenError: false,
    isDiseaseFoundLoaded: false,
    isDiseaseFoundError: false,
    isDiseaseFoundLoadedError: false,
    isPackageSubscriptionHistoryLoaded: false,
    isPackageSubscriptionHistoryError: false,
    isPaymentHistoryLoaded: false,
    isPaymentHistoryError: false,
    isPatientsStatisticsLoadedSex: false,
    isPatientsStatisticsLoadedSexError: false,
    isPatientsStatisticsLoadedAge: false,
    isPatientsStatisticsLoadedAgeError: false,
    isFundusStatisticsLoadedStatus: false,
    isFundusStatisticsLoadedStatusError: false,
    isFundusStatisticsLoadedDevice: false,
    isFundusStatisticsLoadedDeviceError: false,
    isAIGradeabilityLoaded: false,
    isAIGradeabilityLoadedError: false,
    isAIDiagnosisLoaded: false,
    isAIDiagnosisLoadedError: false,
    isWorldMapLoaded: false
  };
  chartsData = {
    servicesTakenData: {},
    diseaseFoundData: {
      pie: {},
      line: []
    },
    packageSubscriptionHistoryData: {},
    paymentHistoryData: {
      pie: {},
      line: []
    },
    patientsStatisticsSexData: {
      pie: {},
      line: []
    },
    patientsStatisticsAgeData: {
      pie: {},
      line: []
    },
    fundusStatisticsStatus: {
      pie: {},
      line: []
    },
    fundusStatisticsDevice: {
      pie: {},
      line: []
    },
    aiGradeabilityData: {
      pie: {},
      line: []
    },
    aiDiagnosisData: {
      pie: {},
      line: []
    }
  };
  modalTitle: string;
  expandedChartsData: ModalData[];
  chartExtendedModalData = {};
  @ViewChild('installedLocationMap', { static: true }) installedLocationMap: ModalDirective;
  @ViewChild('chartExtendedView', { static: true }) chartExtendedView: ModalDirective;
  @ViewChild('dateRangePicker', { static: true }) dateRangePickerView;
  @ViewChild('filterAccount', { static: true }) filterAccountView: NgSelectModuleCustom;
  @ViewChild('filterScreeningCenter') filterScreeningCenterView: NgSelectModuleCustom;

  // aiAnalysisData = [{
  //   "category": "MINE",
  //   "val1start": 0,
  //   "val1end": 78,
  //   "val1label": 78,
  //   "val2start": 100,
  //   "val2end": 133,
  //   "val2label": 33,
  //   "val3start": 200,
  //   "val3end": 258,
  //   "val3label": 58,
  //   "val4start": 300,
  //   "val4end": 344,
  //   "val4label": 44,
  //   "val5start": 400,
  //   "val5end": 462,
  //   "val5label": 62,
  //   "val6start": 500,
  //   "val6end": 500,
  //   "val6label": 0
  // }, {
  //   "category": "ARDA",
  //   "val1start": 0,
  //   "val1end": 55,
  //   "val1label": 55,
  //   "val2start": 100,
  //   "val2end": 163,
  //   "val2label": 63,
  //   "val3start": 200,
  //   "val3end": 274,
  //   "val3label": 74,
  //   "val4start": 300,
  //   "val4end": 341,
  //   "val4label": 41,
  //   "val5start": 400,
  //   "val5end": 471,
  //   "val5label": 71,
  //   "val6start": 500,
  //   "val6end": 562,
  //   "val6label": 62
  // }, {
  //   "category": "Airdoc",
  //   "val1start": 0,
  //   "val1end": 59,
  //   "val1label": 59,
  //   "val2start": 100,
  //   "val2end": 189,
  //   "val2label": 89,
  //   "val3start": 200,
  //   "val3end": 244,
  //   "val3label": 44,
  //   "val4start": 300,
  //   "val4end": 363,
  //   "val4label": 63,
  //   "val5start": 400,
  //   "val5end": 435,
  //   "val5label": 35,
  //   "val6start": 500,
  //   "val6end": 500,
  //   "val6label": 0
  // }, {
  //   "category": "Eyenuk",
  //   "val1start": 0,
  //   "val1end": 31,
  //   "val1label": 31,
  //   "val2start": 100,
  //   "val2end": 155,
  //   "val2label": 55,
  //   "val3start": 200,
  //   "val3end": 286,
  //   "val3label": 86,
  //   "val4start": 300,
  //   "val4end": 360,
  //   "val4label": 60,
  //   "val5start": 400,
  //   "val5end": 445,
  //   "val5label": 45,
  //   "val6start": 500,
  //   "val6end": 500,
  //   "val6label": 0
  // }, {
  //   "category": "Ray8",
  //   "val1start": 0,
  //   "val1end": 36,
  //   "val1label": 36,
  //   "val2start": 100,
  //   "val2end": 165,
  //   "val2label": 65,
  //   "val3start": 200,
  //   "val3end": 235,
  //   "val3label": 35,
  //   "val4start": 300,
  //   "val4end": 378,
  //   "val4label": 78,
  //   "val5start": 400,
  //   "val5end": 448,
  //   "val5label": 48,
  //   "val6start": 500,
  //   "val6end": 500,
  //   "val6label": 0
  // }, {
  //   "category": "Korea 1",
  //   "val1start": 0,
  //   "val1end": 66,
  //   "val1label": 66,
  //   "val2start": 100,
  //   "val2end": 169,
  //   "val2label": 69,
  //   "val3start": 200,
  //   "val3end": 271,
  //   "val3label": 71,
  //   "val4start": 300,
  //   "val4end": 361,
  //   "val4label": 61,
  //   "val5start": 400,
  //   "val5end": 449,
  //   "val5label": 49,
  //   "val6start": 500,
  //   "val6end": 500,
  //   "val6label": 0
  // }];

  constructor(
    public foruscareService: ForuscareService,
    public userService: UserService,
    public accountService: AccountService,
    public dashboardService: DashboardService,
    private ngIdleService:NgIdleService,
    @Inject(DOCUMENT) document: Document
  ) { }

  ngOnInit() {
    this.ngIdleService.reset();
    this.customDateFormat = this.foruscareService.getDateFormat().split(" ")[0];
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
    const fromMin = new Date();
    fromMin.setFullYear(today.getFullYear() - 1);
    const fromMax = new Date();
    const toMin = new Date();
    toMin.setFullYear(today.getFullYear() - 1);
    const toMax = new Date();

    this.setupPresets();
    this.calendarOptions = {
      presets: this.presets,
      //format: 'mediumDate',
      format:this.foruscareService.getDateFormat().split(" ")[0],
      range: {
        fromDate: startDate,
        toDate: today
      },
      fromMinMax: {
        fromDate: fromMin,
        toDate: fromMax
      },
      toMinMax: {
        fromDate: toMin,
        toDate: toMax
      },
      applyLabel: 'Submit',
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: true,
        hasBackdrop: true
      }
    };
    this.selectedDateRange = {
      fromDate: startDate,
      toDate: today
    };
    this.dateRangeView = this.getDateRangeString(this.selectedDateRange);
    this.doc = document;
    this.lazyLoadOnScrollCallback = _.debounce(this.lazyLoadOnScroll, 50);

    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.lazyLoadOnScrollCallback);

    this.getAccounts();
    this.getOverallDetails();
    this.initialCalls();
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.lazyLoadOnScrollCallback);
  }

  setupPresets() {
    const backDate = (numOfDays: number) => {
      const currentDate = new Date();
      return new Date(currentDate.setDate(currentDate.getDate() - numOfDays));
    };

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7);
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    // const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: 'Yesterday', range: { fromDate: yesterday, toDate: yesterday } },
      { presetLabel: 'Last 7 Days', range: { fromDate: minus7, toDate: today } },
      { presetLabel: 'Last 30 Days', range: { fromDate: minus30, toDate: today } },
      { presetLabel: 'This Month', range: { fromDate: currMonthStart, toDate: today } },
      { presetLabel: 'Last Month', range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ];
  }

  lazyLoadOnScroll = (): void => {
    if ( this.sectionScrolled === 120 ) {
      return;
    }

    const scrollHeightMax = Math.max( this.doc.body.scrollHeight, this.doc.body.offsetHeight,
      this.doc.documentElement.clientHeight, this.doc.documentElement.scrollHeight, this.doc.documentElement.offsetHeight );
    const viewportHeight = scrollHeightMax - window.innerHeight;
    const currentScrollPosition = window.pageYOffset;
    // console.log('current scroll', (currentScrollPosition / viewportHeight) * 100 );
    // console.log('this.sectionScrolled', this.sectionScrolled);

    // On >= 80% page scroll next segment of dashboard is loaded
    if ( (currentScrollPosition / viewportHeight) >= 0.8 ) {
      this.sectionScrolled += 20;
      this.renderCharts();
    }
  }

  getDateRangeString(daterange: Range): string {
    const fromDateString: string[] = daterange.fromDate.toDateString().split(' ');
    const toDateString: string[] = daterange.toDate.toDateString().split(' ');

    return `${fromDateString[1]} ${fromDateString[2]}, ${fromDateString[3]} - ${toDateString[1]} ${toDateString[2]}, ${toDateString[3]}`;
  }

  sortAlphaNumeric(a: any , b: any, propertyName: string): Number {
    if ( a[propertyName] && b[propertyName] ) {
      let A = a[propertyName];
      let B = b[propertyName];

      // convert to strings and force lowercase
      A = (typeof A === 'string') ? A.toLowerCase() : A.toString();
      B = (typeof b === 'string') ? B.toLowerCase() : B.toString();

      return A.localeCompare(B);
    } else {
      return 0;
    }
  }

  getAccounts(): void {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe((response: ResponseObject) => {
        if ( response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS ) {
          if (response.data !== null) {
            this.accounts = response.data.sort( (a: any, b: any) => this.sortAlphaNumeric(a, b, 'accountName') );
          }
        } else {
          this.foruscareService.showNotification(response.message, 'danger');
        }
      });
  }

  getScreeningCentersByAccountID(): void {
    if (this.accountId !== null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.screeningCenters = response.data.sort( (a: any, b: any) => this.sortAlphaNumeric(a, b, 'orgName') );
              // this.orgId = null;
              this.filterScreeningCenterView.handleClearClick();
            }
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
          }
        });
    }
  }

  screeningCenterSelected(): void {
    this.resetDashboard();
  }

  clearFilterAccount(): void {
    this.orgId = null;
    this.resetDashboard();
  }

  clearFilterScreeningCenter(): void {
    this.resetDashboard();
  }

  getOverallDetails(): void {
    this.dashboardService.getOverallDetails()
      .subscribe((response: ResponseObject) => {
        if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
          if (response.data !== null) {
            this.overallDetailsData = response.data;
            this.isOverallDataRowLoaded = true;
          }
        } else {
          this.foruscareService.showNotification(response.message, 'danger');
        }
      });
  }

  initialCalls(): void {
    this.loadServicesTakenChart(CHART_TYPE.LINE);
    this.loadDiseaseFoundChart(CHART_TYPE.PIE);
  }

  // handler function that receives the updated date range object
  updateDateRange(updatedRange: Range): void {
    if ( _.isEqual(this.selectedDateRange, updatedRange) ) {
      return;
    }

    const selectedFromYear = updatedRange.fromDate.getFullYear();
    const selectedToYear = updatedRange.toDate.getFullYear();
    const selectedFromMonth = updatedRange.fromDate.getMonth();
    const selectedToMonth = updatedRange.toDate.getMonth();
    const selectedFromDate = updatedRange.fromDate.getDate();
    const selectedToDate = updatedRange.toDate.getDate();
    let isDateSwitched = false;

    if ( selectedToYear < selectedFromYear) {
      isDateSwitched = true;
    }

    if ( selectedToYear === selectedFromYear && selectedToMonth < selectedFromMonth ) {
      isDateSwitched = true;
    }

    if ( (selectedToYear > selectedFromYear || selectedToYear === selectedFromYear) && selectedFromMonth === selectedToMonth && selectedToDate < selectedFromDate ) {
      isDateSwitched = true;
    }

    this.selectedDateRange = updatedRange;
    this.dateRangeView = this.getDateRangeString(this.selectedDateRange);

    if (isDateSwitched) {
      const from = updatedRange.fromDate;
      const to = updatedRange.toDate;
      updatedRange = {
        fromDate: to,
        toDate: from
      };

      this.dateRangePickerView.resetDates(updatedRange);
    } else {
      this.resetDashboard();
    }
  }

  viewInstalledLocationMap() {
    this.installedLocationMap.show();
    this.charts.isWorldMapLoaded = true;
  }

  closeInstalledLocationModel() {
    this.installedLocationMap.hide();
    this.charts.isWorldMapLoaded = false;
  }

  getSortedLineChartDataByDate(lineChartData: any[]): any[] {
    const sortedData = lineChartData.map((item: any) => {
      Object.keys(item).forEach((key: string) => {
        if (item[key] === 'dateString') {
          item[key] = item[key].replace(/-/g, '/');
        }

        if (item[key] === null || item[key] === undefined) {
          delete item[key];
        }
      });

      return item;
    });

    return _.sortBy(sortedData, ['dateString']);
  }

  showExpandedViewOfChart(id: string,  type: string): void {
    this.expandedChartsData = [];

    switch (id) {
    case 'servicesTaken': {
      if (type === CHART_TYPE.LINE) {
        const data: ModalData = {
          id,
          type: 'multiline',
          title: 'Disease Found',
          chartTitle: '',
          chartData: this.chartsData.servicesTakenData,
          valueField: '',
          titleField: '',
          isLoaded: this.charts.isServicesTakenLoaded
        };

        this.modalTitle = `Services Utilized between ${this.dateRangeView}`;
        this.expandedChartsData.push(data);
      }

      break;
    }

    case 'diseasesFound': {
      if (type === CHART_TYPE.PIE) {
        const data: ModalData = {
          id,
          type,
          title: 'Disease Found',
          chartTitle: '',
          chartData: this.chartsData.diseaseFoundData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isDiseaseFoundLoaded
        };

        this.modalTitle = `Disease Found between ${this.dateRangeView}`;
        this.expandedChartsData.push(data);
      }

      if (type === CHART_TYPE.LINE) {
        this.dashboardService.getDiseaseFoundDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE)
          .subscribe((response: any) => {
            if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
              if (response.data !== null && !_.isEmpty(response.data)) {
                this.chartsData.diseaseFoundData.line = this.getSortedLineChartDataByDate(response.data);

                const data: ModalData = {
                  id,
                  type: 'multiline',
                  title: 'Services Taken',
                  chartTitle: '',
                  chartData: this.chartsData.diseaseFoundData.line,
                  valueField: '',
                  titleField: '',
                  isLoaded: this.charts.isDiseaseFoundLoaded
                };

                this.modalTitle = `Disease Found between ${this.dateRangeView}`;
                this.expandedChartsData.push(data);
              }
            } else {
              this.foruscareService.showNotification(response.message, 'danger');
            }
          });
      }

      break;
    }

    case 'packageSubscription': {
      if (type === CHART_TYPE.LINE) {
        const data = {
          id,
          type: 'multiline',
          title: 'Package Subscription',
          chartTitle: '',
          chartData: this.chartsData.packageSubscriptionHistoryData,
          valueField: '',
          titleField: '',
          isLoaded: this.charts.isPackageSubscriptionHistoryLoaded
        };

        this.modalTitle = `Package Subscription History between ${this.dateRangeView}`;
        this.expandedChartsData.push(data);
      }

      break;
    }

    case 'paymenthistory': {
      if (type === CHART_TYPE.PIE) {
        const data: ModalData = {
          id,
          type,
          title: 'Payment History',
          chartTitle: '',
          chartData: this.chartsData.paymentHistoryData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isPaymentHistoryLoaded
        };

        this.modalTitle = `Payment History between ${this.dateRangeView}`;
        this.expandedChartsData.push(data);
      }
      break;
    }

    case 'patients': {
      if (type === CHART_TYPE.PIE) {
        const data1: ModalData = {
          id: 'patientsSex',
          type,
          title: 'Patients Sex',
          chartTitle: 'Gender',
          chartData: this.chartsData.patientsStatisticsSexData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isPatientsStatisticsLoadedSex
        };

        const data2: ModalData = {
          id: 'patientsAge',
          type,
          title: 'Patients Age',
          chartTitle: 'Age',
          chartData: this.chartsData.patientsStatisticsAgeData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isPatientsStatisticsLoadedAge
        };

        this.modalTitle = `Patients Statistics between ${this.dateRangeView}`;
        this.expandedChartsData.push(data1, data2);
      }

      if (type === CHART_TYPE.LINE) {
        this.dashboardService.getPatientsAgeDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE)
          .subscribe((response: ResponseObject) => {
            if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
              if (response.data !== null && !_.isEmpty(response.data)) {
                // converting the age-range labels
                this.chartsData.patientsStatisticsAgeData.line = this.getSortedLineChartDataByDate(response.data).map((item) => {
                  return {
                    'dateString': item.dateString,
                    '0-20 years': item.zeroToTwenty,
                    '21-40 years': item.twentyToForty,
                    '41-60 years': item.fortyToSixty,
                    'Above 60 years': item.aboveSixty
                  };
                });

                const data: ModalData = {
                  id,
                  type: 'multiline',
                  title: 'Patients Age',
                  chartTitle: '',
                  chartData: this.chartsData.patientsStatisticsAgeData.line,
                  valueField: '',
                  titleField: '',
                  isLoaded: this.charts.isPatientsStatisticsLoadedAge
                };

                this.modalTitle = `Patients' Age between ${this.dateRangeView}`;
                this.expandedChartsData.push(data);
              }
            } else {
              this.foruscareService.showNotification(response.message, 'danger');
            }
          });
      }

      break;
    }

    case 'fundus': {
      if (type === CHART_TYPE.PIE) {
        const data1: ModalData = {
          id: 'fundusStatus',
          type,
          title: 'Fundus Status',
          chartTitle: 'Status',
          chartData: this.chartsData.fundusStatisticsStatus.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isFundusStatisticsLoadedStatus
        };

        const data2: ModalData = {
          id: 'fundusDevice',
          type,
          title: 'Fundus Device',
          chartTitle: 'Devices',
          chartData: this.chartsData.fundusStatisticsDevice.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isFundusStatisticsLoadedDevice
        };

        this.modalTitle = `Fundus Statistics between ${this.dateRangeView}`;
        this.expandedChartsData.push(data1, data2);
      }

      if (type === CHART_TYPE.LINE) {
        const fundusStatusLineData = this.dashboardService.getFundusStatusDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE);
        const fundusDeviceLineData = this.dashboardService.getFundusDeviceDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE);

        forkJoin([fundusStatusLineData, fundusDeviceLineData])
          .subscribe((responses: ResponseObject[]) => {
            this.chartsData.fundusStatisticsStatus.line = this.getSortedLineChartDataByDate(responses[0].data).map((item) => {
              return {
                'dateString': item.dateString,
                'Ready for review': item.readyForReview,
                'Ready for download': item.readyForDownload,
                'Rejected': item.rejected,
                'Uploading': item.uploading,
                'Approval Done': item.approvalDone,
                'Assigned for review': item.assignedForReview
              };
            });

            this.chartsData.fundusStatisticsDevice.line = this.getSortedLineChartDataByDate(responses[1].data).map((item) => {
              return {
                'dateString': item.dateString,
                'Classic': item.classic,
                'Classic HD': item.classicHd,
                'Neo': item.neo,
                'Crystal View': item.crystalView
              };
            });

            const data1: ModalData = {
              id: 'fundusStatus',
              type: 'multiline',
              title: 'Fundus Status',
              chartTitle: '',
              chartData: this.chartsData.fundusStatisticsStatus.line,
              valueField: '',
              titleField: '',
              isLoaded: this.charts.isFundusStatisticsLoadedStatus
            };

            const data2: ModalData = {
              id: 'fundusDevice',
              type: 'multiline',
              title: 'Fundus Device',
              chartTitle: '',
              chartData: this.chartsData.fundusStatisticsDevice.line,
              valueField: '',
              titleField: '',
              isLoaded: this.charts.isFundusStatisticsLoadedDevice
            };

            this.modalTitle = `Fundus Statistics between ${this.dateRangeView}`;
            this.expandedChartsData.push(data1, data2);
          });
      }
      break;
    }

    case 'aiStatistics': {
      if (type === CHART_TYPE.PIE) {
        const data1: ModalData = {
          id: 'aiGradeable',
          type,
          title: 'AI Gradeable',
          chartTitle: 'Gradeability',
          chartData: this.chartsData.aiGradeabilityData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isAIGradeabilityLoaded
        };

        const data2: ModalData = {
          id: 'aiDiagonsis',
          type,
          title: 'AI Diagnosis',
          chartTitle: 'Diagnosis',
          chartData: this.chartsData.aiDiagnosisData.pie,
          valueField: 'fieldValue',
          titleField: 'fieldName',
          isLoaded: this.charts.isAIDiagnosisLoaded
        };

        this.modalTitle = `AI Gradeability/Diagnosis Statistics between ${this.dateRangeView}`;
        this.expandedChartsData.push(data1, data2);
      }

      if (type === CHART_TYPE.LINE) {
        const aiGradeabilityLineData = this.dashboardService.getAIGradeabilityDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE);
        const aiDiagnosisLineData = this.dashboardService.getAIDiagnosisDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE);

        forkJoin([aiGradeabilityLineData, aiDiagnosisLineData])
          .subscribe((responses: ResponseObject[]) => {
            this.chartsData.aiGradeabilityData.line = this.getSortedLineChartDataByDate(responses[0].data).map((item) => {
              return {
                'dateString': item.dateString,
                'Gradeable': item.gradeable,
                'Non Gradeable': item.nonGradeable,
              };
            });

            this.chartsData.aiDiagnosisData.line = this.getSortedLineChartDataByDate(responses[1].data).map((item) => {
              return {
                'dateString': item.dateString,
                'DR': item.dr,
                'DME': item.dme
              };
            });

            const data1: ModalData = {
              id: 'aiGradeable',
              type: 'multiline',
              title: 'AI Gradeability',
              chartTitle: '',
              chartData: this.chartsData.aiGradeabilityData.line,
              valueField: '',
              titleField: '',
              isLoaded: this.charts.isAIGradeabilityLoaded
            };

            const data2: ModalData = {
              id: 'aiDiagonsis',
              type: 'multiline',
              title: 'AI Diagnosis',
              chartTitle: '',
              chartData: this.chartsData.aiDiagnosisData.line,
              valueField: '',
              titleField: '',
              isLoaded: this.charts.isAIDiagnosisLoaded
            };

            this.modalTitle = `AI Statistics between ${this.dateRangeView}`;
            this.expandedChartsData.push(data1, data2);
          });
      }
      break;
    }
    }

    this.chartExtendedView.show();
    this.isChartExtended = true;
  }

  closeExpandedViewOfChart() {
    this.isChartExtended = false;
    this.chartExtendedView.hide();
  }

  resetDashboard(): void {
    for (const value in this.charts) {
      if (this.charts[value] === true) {
        this.charts[value] = false;
      }
    }

    this.sectionScrolled = 0;

    this.initialCalls();
  }

  isAllFieldValueEmpty(responseData: any): boolean {
    let fieldValuesEmpty = true;

    responseData.forEach((item: any) => {
      if (item.fieldValue !== '0') {
        fieldValuesEmpty = false;
      }
    });

    return fieldValuesEmpty;
  }

  renderCharts(): void {
    switch (this.sectionScrolled) {
      case 20: {
        this.loadPackageSubscriptionHistoryChart(CHART_TYPE.LINE);
        this.loadPaymentHistoryChart(CHART_TYPE.PIE);
        break;
      }

      case 40: {
        this.loadPatientsStatisticsChart(CHART_TYPE.PIE);
        break;
      }

      case 60: {
        this.loadFundusStatusChart(CHART_TYPE.PIE);
        break;
      }

      case 80: {
        this.loadAIGradeabilityChart(CHART_TYPE.PIE);
        break;
      }

      case 100: {

        break;
      }
    }
  }

  loadServicesTakenChart(type: string): void {
    switch (type) {
      case CHART_TYPE.LINE: {
        this.dashboardService.getServicesTakenDetails(this.selectedDateRange, this.accountId, this.orgId)
          .subscribe((response: ResponseObject) => {
            if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
              if (response.data !== null && !_.isEmpty(response.data)) {
                this.chartsData.servicesTakenData = this.getSortedLineChartDataByDate(response.data);

                this.charts.isServicesTakenLoaded = true;
              }
            } else {
              this.foruscareService.showNotification(response.message, 'danger');
              this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
              this.charts.isServicesTakenLoaded = true;
              this.charts.isServicesTakenError = true;
            }
          });
      }
    }
  }

  loadDiseaseFoundChart(type: string): void {
    switch (type) {
    case CHART_TYPE.PIE: {
      this.dashboardService.getDiseaseFoundDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data)) {
              this.chartsData.diseaseFoundData.pie = response.data;
            } else {
              this.chartsData.diseaseFoundData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isDiseaseFoundLoaded = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isDiseaseFoundLoaded = true;
            this.charts.isDiseaseFoundError = true;
          }
        });
      break;
    }

    case CHART_TYPE.LINE: {
      this.dashboardService.getDiseaseFoundDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.LINE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data)) {
              this.chartsData.diseaseFoundData.line = response.data;
            }
          }});
      break;
    }
    }
  }

  loadPackageSubscriptionHistoryChart(type: string): void {
    switch (type) {
      case CHART_TYPE.LINE: {
        this.dashboardService.getPackageSubscriptionHistoryDetails(this.selectedDateRange, this.accountId, this.orgId)
          .subscribe((response: ResponseObject) => {
            if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
              if (response.data !== null && !_.isEmpty(response.data)) {
                this.chartsData.packageSubscriptionHistoryData = this.getSortedLineChartDataByDate(response.data);

                this.charts.isPackageSubscriptionHistoryLoaded =  true;
              }
            } else {
              this.foruscareService.showNotification(response.message, 'danger');
              this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
              this.chartsData.packageSubscriptionHistoryData = {};
              this.charts.isPackageSubscriptionHistoryLoaded =  true;
              this.charts.isPackageSubscriptionHistoryError =  true;
            }
          });


        break;
      }
    }
  }

  loadPaymentHistoryChart(type: string): void {
    switch (type) {
      case CHART_TYPE.PIE: {
        this.dashboardService.getPaymentHistoryDetails(this.selectedDateRange, this.accountId, this.orgId)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data) && !this.isAllFieldValueEmpty(response.data)) {
              this.chartsData.paymentHistoryData.pie = response.data;
            } else {
              this.chartsData.paymentHistoryData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isPaymentHistoryLoaded = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isPaymentHistoryLoaded = true;
            this.charts.isPaymentHistoryError = true;
          }
        });

        break;
      }

      case CHART_TYPE.LINE: {
        break;
      }
    }
  }

  loadPatientsStatisticsChart(type: string): void {
    switch (type) {
    case CHART_TYPE.PIE: {
      this.dashboardService.getPatientsSexDetails(this.selectedDateRange, this.accountId, this.orgId)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data) && response.data[0].fieldValue !== null) {
              this.chartsData.patientsStatisticsSexData.pie = response.data;
            } else {
              this.chartsData.patientsStatisticsSexData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isPatientsStatisticsLoadedSex = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isPatientsStatisticsLoadedSex = true;
            this.charts.isPatientsStatisticsLoadedSexError = true;
          }
        });

      this.dashboardService.getPatientsAgeDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data) && response.data[0].fieldValue !== null) {
              this.chartsData.patientsStatisticsAgeData.pie = response.data;
            } else {
              this.chartsData.patientsStatisticsAgeData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isPatientsStatisticsLoadedAge = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isPatientsStatisticsLoadedAge = true;
            this.charts.isPatientsStatisticsLoadedAgeError = true;
          }
        });

      break;
    }
    }
  }

  loadFundusStatusChart(type: string): void {
    switch (type) {
    case CHART_TYPE.PIE: {
      this.dashboardService.getFundusStatusDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data)) {
              this.chartsData.fundusStatisticsStatus.pie = response.data;
            } else {
              this.chartsData.fundusStatisticsStatus.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isFundusStatisticsLoadedStatus = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isFundusStatisticsLoadedStatus = true;
            this.charts.isFundusStatisticsLoadedStatusError = true;
          }
        });

        this.dashboardService.getFundusDeviceDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data)) {
              this.chartsData.fundusStatisticsDevice.pie = response.data;
            } else {
              this.chartsData.fundusStatisticsDevice.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isFundusStatisticsLoadedDevice = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isFundusStatisticsLoadedDevice = true;
            this.charts.isFundusStatisticsLoadedDeviceError = true;
          }
        });

      break;
    }
    }
  }

  loadAIGradeabilityChart(type: string): void {
    switch (type) {
    case CHART_TYPE.PIE: {
      this.dashboardService.getAIGradeabilityDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data) && !this.isAllFieldValueEmpty(response.data)) {
              this.chartsData.aiGradeabilityData.pie = response.data;
            } else {
              this.chartsData.aiGradeabilityData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isAIGradeabilityLoaded = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isAIGradeabilityLoaded = true;
            this.charts.isAIGradeabilityLoadedError = true;
          }
        });

        this.dashboardService.getAIDiagnosisDetails(this.selectedDateRange, this.accountId, this.orgId, CHART_TYPE.PIE)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
            if (response.data !== null && !_.isEmpty(response.data) && !this.isAllFieldValueEmpty(response.data)) {
              this.chartsData.aiDiagnosisData.pie = response.data;
            } else {
              this.chartsData.aiDiagnosisData.pie = [
                {
                  fieldName: CHART_TYPE.NO_DATA.text,
                  fieldValue: 1,
                  color:  CHART_TYPE.NO_DATA.color
                }
              ];
            }

            this.charts.isAIDiagnosisLoaded = true;
          } else {
            this.foruscareService.showNotification(response.message, 'danger');
            this.chartDataErrorMessage = `There is some error in retrieving data between ${this.dateRangeView}`;
            this.charts.isAIDiagnosisLoaded = true;
            this.charts.isAIDiagnosisLoadedError = true;
          }
        });

      break;
    }
    }

  }
}
